module.exports = __webpack_public_path__ + "static/media/p4_7.d5ee474d.png";